export default "__VITE_ASSET__qYparMj2__"